<template>
    <div class="cpo-cta">
        <!-- <pre v-if="cta" v-text="cta"></pre> -->

        <div class="cpo-cta--root">
            <component :is="cta.type" :plugin="cta"></component>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            cta: Object,
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?13eba05f